import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ResultReportsModel } from 'common/models/page-models/reports/result-reports/result-reports-data.model';
import { ReportFilterMetaModel } from 'common/models/page-models/reports/result-reports/result-reports-filter-meta.model';
import { InternshipDetailsListModel } from 'common/models/page-models/Student Internship List/Intership Details/internship-details-data.model';
import { InternshipDetailsListListingModel } from 'common/models/page-models/Student Internship List/Intership Details/internship-details-model';
import { InternshipFilterModel } from 'common/models/page-models/Student Internship List/Intership Filter Form/internship-list-filter-data.model';
import { InternshipFilterMetaModel } from 'common/models/page-models/Student Internship List/Intership Filter Form/internship-list-filter-meta.model';
import { TerminateInternshipModel } from 'common/models/page-models/Student Internship List/Terminate Internship/terminate-internship-data.model';
import { TerminateInternshipMetaModel } from 'common/models/page-models/Student Internship List/Terminate Internship/terminate-internship-meta.model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { InternshipDetailsGridWidgetService } from 'common/widget/intership Listing/intership-details-list-widget.service';


@Injectable({
    providedIn: 'root'
})
export class InternshipDetailsGridResolver extends GridResolver<InternshipDetailsListModel, InternshipDetailsListListingModel> {
    constructor(
        protected fs: InternshipDetailsGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

        // console.log("called")
        
    }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        dataModel['filterData'] = new InternshipFilterModel();
        return dataModel;
    }
 
    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties?.recordPerPage;
        widget.searchableFeilds = metaModel.properties?.searchableFields;
        transferData.filterData = new InternshipFilterModel();
        transferData.filterMeta = new InternshipFilterMetaModel().getMetaModel();
        transferData.formData = new TerminateInternshipModel();
        transferData.formMeta = new TerminateInternshipMetaModel().getMetaModel();
        this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }
}
